import { render, staticRenderFns } from "./OfferItemEmphasis.vue?vue&type=template&id=3b8d4fca"
import script from "./OfferItemEmphasis.vue?vue&type=script&lang=js"
export * from "./OfferItemEmphasis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b8d4fca')) {
      api.createRecord('3b8d4fca', component.options)
    } else {
      api.reload('3b8d4fca', component.options)
    }
    module.hot.accept("./OfferItemEmphasis.vue?vue&type=template&id=3b8d4fca", function () {
      api.rerender('3b8d4fca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/OfferItemEmphasis.vue"
export default component.exports